export default __webpack_public_path__ + "static/media/blog.57da9ae8.less";